<template>
  <el-dialog
    :visible.sync="innerVisible"
    class="currentPeriodCostRecordsDiaLog"
    id="currentPeriodCostRecordsDiaLog"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    :append-to-body="true"
    width="720px"
  >
    <template slot="title">
      <div class="dialog-title-wrap">
        <div class="dialog-title-label">
          {{ innerActiveName === 'first' ? '今日消费总计' : '今日收入总计' }}
        </div>
        <div class="dialog-title-value">
          {{ innerActiveName === 'first' ? costTotal : incomeTotal }}
          <IconSvg :icon-style="'icon'" icon-class="icon-fuqian" />
        </div>
      </div>
    </template>

    <el-tabs
      v-model="innerActiveName"
      type="card"
      @tab-click="$emit('tab-click', $event)"
      class="records-tabs"
    >
      <!-- 消费信息 -->
      <el-tab-pane label="消费信息" name="first">
        <div v-if="!costList || !costList.length" class="empty-tip">
          暂无消费记录
        </div>
        <div v-else class="record-list">
          <div
            v-for="item in costList"
            :key="item.id || item.costTime + '_' + item.costAmount"
            class="record-card record-card-cost"
          >
            <div class="record-card-main">
              <div class="record-card-left">
                <div class="record-icon-wrap">
                  <IconSvg
                    :icon-style="'icon'"
                    :icon-class="item.costTypeIcon"
                    class="record-icon"
                  />
                </div>
                <div class="record-text">
                  <div class="record-title-row">
                    <span class="record-title">{{ item.costTypeName || '未分类' }}</span>
                    <span class="record-capital">
                      <IconSvg
                        v-if="item.capitalIcon"
                        :icon-style="'icon'"
                        :icon-class="item.capitalIcon"
                        class="record-capital-icon"
                      />
                      <span class="record-capital-text">
                        {{ item.capitalResourceName || '资金源未配置' }}
                      </span>
                    </span>
                  </div>
                  <div class="record-desc">
                    {{ item.costDescription || '暂无消费说明' }}
                  </div>
                  <div class="record-meta">
                    <span class="record-meta-label">消费时间</span>
                    <span class="record-meta-value">{{ item.costTime }}</span>
                  </div>
                </div>
              </div>
              <div class="record-amount-wrap">
                <span class="record-amount-prefix">-</span>
                <span class="record-amount-value">{{ item.costAmount }}</span>
                <span class="record-amount-unit">元</span>
              </div>
            </div>

            <div class="record-progress-bar">
              <div class="record-progress-inner record-progress-cost" />
            </div>
          </div>
        </div>
      </el-tab-pane>

      <!-- 收入信息 -->
      <el-tab-pane
        v-if="incomeList && incomeList.length > 0"
        label="收入信息"
        name="second"
      >
        <div v-if="!incomeList || !incomeList.length" class="empty-tip">
          暂无收入记录
        </div>
        <div v-else class="record-list">
          <div
            v-for="item in incomeList"
            :key="item.id || item.incomeDay + '_' + item.amount"
            class="record-card record-card-income"
          >
            <div class="record-card-main">
              <div class="record-card-left">
                <div class="record-icon-wrap">
                  <IconSvg
                    :icon-style="'icon'"
                    :icon-class="item.incomeTypeIcon"
                    class="record-icon"
                  />
                </div>
                <div class="record-text">
                  <div class="record-title-row">
                    <span class="record-title">{{ item.incomeTypeName || '未分类' }}</span>
                    <span class="record-capital">
                      <span class="record-capital-text">收入</span>
                    </span>
                  </div>
                  <div class="record-desc">
                    {{ item.description || '暂无收入说明' }}
                  </div>
                  <div class="record-meta">
                    <span class="record-meta-label">收入时间</span>
                    <span class="record-meta-value">{{ item.incomeDay }}</span>
                  </div>
                </div>
              </div>
              <div class="record-amount-wrap income">
                <span class="record-amount-prefix">+</span>
                <span class="record-amount-value">{{ item.amount }}</span>
                <span class="record-amount-unit">元</span>
              </div>
            </div>

            <div class="record-progress-bar">
              <div class="record-progress-inner record-progress-income" />
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import IconSvg from "@/components/common/IconSvg";

export default {
  name: "HomePeriodRecordsDialog",
  components: { IconSvg },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    activeName: {
      type: String,
      default: "first",
    },
    costList: {
      type: Array,
      default: () => [],
    },
    incomeList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      },
    },
    innerActiveName: {
      get() {
        return this.activeName;
      },
      set(v) {
        this.$emit("update:activeName", v);
      },
    },
    costTotal() {
      let total = 0;
      (this.costList || []).forEach((item) => {
        total = this.$add(total, Number(item.costAmount || 0));
      });
      return total;
    },
    incomeTotal() {
      let total = 0;
      (this.incomeList || []).forEach((item) => {
        total = this.$add(total, Number(item.amount || 0));
      });
      return total;
    },
  },
};
</script>

<style scoped>
.currentPeriodCostRecordsDiaLog >>> .el-dialog {
  background: linear-gradient(160deg, rgba(15, 23, 42, 0.98) 0%, rgba(30, 27, 75, 0.96) 100%);
  border-radius: 16px;
  border: 1px solid rgba(56, 189, 248, 0.35);
  box-shadow:
    0 18px 40px rgba(0, 0, 0, 0.85),
    0 0 30px rgba(56, 189, 248, 0.35),
    0 0 50px rgba(113, 70, 255, 0.3);
  color: #e5e7eb;
}

.currentPeriodCostRecordsDiaLog >>> .el-dialog__header {
  border-bottom: 1px solid rgba(56, 189, 248, 0.4);
}

.dialog-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 4px;
}

.dialog-title-label {
  font-size: 14px;
  letter-spacing: 0.16em;
  color: rgba(148, 163, 184, 0.95);
}

.dialog-title-value {
  font-size: 22px;
  font-weight: 700;
  color: #7dd3fc;
  text-shadow:
    0 0 12px rgba(56, 189, 248, 0.8),
    0 0 22px rgba(129, 140, 248, 0.7);
}

.records-tabs >>> .el-tabs__header {
  margin-bottom: 10px;
}

.records-tabs >>> .el-tabs__item {
  color: rgba(148, 163, 184, 0.9);
}

.records-tabs >>> .el-tabs__item.is-active {
  color: #7dd3fc;
}

.record-list {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 4px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.record-list::-webkit-scrollbar {
  width: 6px;
}

.record-list::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background-image: linear-gradient(
    180deg,
    rgba(56, 189, 248, 0.6),
    rgba(129, 140, 248, 0.8)
  );
}

.record-list::-webkit-scrollbar-track {
  background-color: rgba(15, 23, 42, 0.98);
}

.record-card {
  padding: 10px 14px 8px;
  border-radius: 14px;
  background:
    radial-gradient(circle at 0% 0%, rgba(56, 189, 248, 0.18), transparent 55%),
    radial-gradient(circle at 100% 100%, rgba(129, 140, 248, 0.18), transparent 55%),
    linear-gradient(135deg, rgba(15, 23, 42, 0.98), rgba(17, 24, 39, 0.98));
  border: 1px solid rgba(56, 189, 248, 0.28);
  box-shadow:
    0 10px 22px rgba(15, 23, 42, 0.96),
    0 0 20px rgba(15, 118, 255, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
  cursor: default;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.record-card:hover {
  transform: translateY(-2px);
  box-shadow:
    0 14px 30px rgba(15, 23, 42, 0.98),
    0 0 26px rgba(56, 189, 248, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
  border-color: rgba(56, 189, 248, 0.45);
}

.record-card-main {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  column-gap: 12px;
}

.record-card-left {
  display: flex;
  align-items: flex-start;
  column-gap: 10px;
}

.record-icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: radial-gradient(circle at 30% 0%, rgba(56, 189, 248, 0.4), transparent 65%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.record-icon {
  width: 22px;
  height: 22px;
}

.record-text {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
}

.record-title-row {
  display: flex;
  align-items: center;
  column-gap: 8px;
  margin-bottom: 2px;
}

.record-title {
  font-size: 14px;
  color: rgba(226, 232, 240, 0.96);
  font-weight: 600;
}

.record-capital {
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: rgba(15, 23, 42, 0.85);
  border: 1px solid rgba(56, 189, 248, 0.35);
}

.record-capital-icon {
  width: 14px;
  height: 14px;
}

.record-capital-text {
  font-size: 11px;
  color: rgba(148, 163, 184, 0.98);
}

.record-desc {
  font-size: 12px;
  color: rgba(203, 213, 225, 0.95);
  line-height: 1.5;
}

.record-meta {
  margin-top: 2px;
  font-size: 11px;
  color: rgba(148, 163, 184, 0.96);
}

.record-meta-label {
  margin-right: 4px;
}

.record-meta-value {
  color: rgba(226, 232, 240, 0.95);
}

.record-amount-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  min-width: 120px;
}

.record-amount-wrap.income .record-amount-prefix,
.record-amount-wrap.income .record-amount-value {
  color: #4ade80;
  text-shadow:
    0 0 10px rgba(34, 197, 94, 0.5),
    0 0 18px rgba(56, 189, 248, 0.4);
}

.record-amount-prefix {
  font-size: 14px;
  color: #f97373;
}

.record-amount-value {
  font-size: 18px;
  font-weight: 700;
  color: #facc15;
  text-shadow:
    0 0 10px rgba(250, 204, 21, 0.5),
    0 0 24px rgba(56, 189, 248, 0.35);
}

.record-amount-unit {
  font-size: 11px;
  color: rgba(148, 163, 184, 0.96);
}

.record-progress-bar {
  margin-top: 8px;
  width: 100%;
  height: 5px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(30, 64, 175, 0.75), rgba(15, 23, 42, 0.98));
  overflow: hidden;
}

.record-progress-inner {
  width: 65%;
  height: 100%;
  border-radius: 999px;
}

.record-progress-cost {
  background: linear-gradient(90deg, rgba(56, 189, 248, 0.95), rgba(59, 130, 246, 0.95));
  box-shadow:
    0 0 10px rgba(56, 189, 248, 0.9),
    0 0 16px rgba(37, 99, 235, 0.9);
}

.record-progress-income {
  background: linear-gradient(90deg, rgba(45, 212, 191, 0.95), rgba(59, 130, 246, 0.95));
  box-shadow:
    0 0 10px rgba(45, 212, 191, 0.9),
    0 0 16px rgba(37, 99, 235, 0.9);
}

.empty-tip {
  padding: 40px 0;
  text-align: center;
  color: rgba(148, 163, 184, 0.9);
  font-size: 13px;
}
</style>

